// extracted by mini-css-extract-plugin
module.exports = {"text":"components-DeleteUserSuccess-DeleteUserSuccess__text--1Zk9R"};